// extracted by mini-css-extract-plugin
export default {"root":"_3BWrU","icon":"_3pKU8","up":"yhjAi","right":"O0_IJ"};